import { Autocomplete, FormControl, FormHelperText, TextField } from '@mui/material'
import './index.scss'

export default function BasicSelect({ className = '', label, value, options = [], onChange, error, placeholder }) {
  return (
    <FormControl fullWidth margin="normal" error={Boolean(error)} className={`TrafficViolationsBasicSelect ${className}`.trim()}>
      <Autocomplete
        disableClearable
        value={value || null}
        options={options}
        getOptionLabel={(option) => option?.label || ''}
        isOptionEqualToValue={(option, selectedValue) => option?.value === selectedValue?.value}
        onChange={(_, nextValue) => onChange?.(nextValue)}
        renderInput={(params) => <TextField {...params} label={label} placeholder={placeholder} />}
      />
      <FormHelperText>{error || ''}</FormHelperText>
    </FormControl>
  )
}
